export const marketingSiteBaseUrl = 'https://joincoa.com';
export const marketingSiteDomainName = 'joincoa.com';

export type WindowWithWww = {
  BASE_URL: string;
};
